import { addDays, addMonths, addYears } from "date-fns";

export const subtractUnits = (numStr: string, unit: "days" | "months" | "years"): Date => {
	const date = new Date();
	const num = parseInt(numStr, 10) * -1;
	switch (unit) {
		case "days":
			return addDays(date, num);
		case "months":
			return addMonths(date, num);
		case "years":
			return addYears(date, num);
	}
};
